<template>
  <div>
    <template >
      <!-- 计算总数分页 -->
      <vxe-pager v-if="isShowTotal"
                 :current-page="page.currentPage"
                 :page-size.sync="page.pageSize"
                 :total="tableDataTotal"
                 :page-sizes="pageSizes"
                 :layouts="['PrevPage', 'Number', 'NextPage', 'Sizes',]"
                 @page-change="bindChangeTablePage"
      >
        <template #right>
          <div style="display:flex;height: 25px;">
            <div style="margin: 0 20px; height: 20px;">当前记录<span style="color:#ff731c;margin-left: 10px;">{{tableDataTotal}}</span></div>
            <div @click="changeShowTotal(false)">
              <svg class="icon" style=" height: 18px; width: 18px;margin: 0px 0px;margin-top: 5px;" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg">
                <path d="M906.189827 476.775754l-50.251497-45.89119c14.805194-18.579147 25.444509-36.192294 31.202653-51.237965l0.535189-1.446955c0.306992-0.74292 0.584308-1.486864 0.812505-2.220574l2.536776-6.90834-1.36816-0.366344c0-0.049119 0-0.089028 0-0.13917 0-14.608719-11.892865-26.502607-26.511817-26.502607-10.158361 0-18.919908 5.629207-23.340591 14.014178l-0.306992-0.069585-0.921999 2.764973c-0.317225 0.802272-0.594541 1.62501-0.832971 2.468215l-1.169639 3.479241c-21.269419 63.381539-160.659073 179.787736-324.579423 179.787736-166.932963 0-307.670312-119.786177-325.580217-182.423773l-2.815115-9.148357-1.397836 0.306992c-4.797259-6.868431-12.636808-11.17962-21.339004-11.17962-14.618952 0-26.511817 11.892865-26.511817 26.502607 0 3.329838 0.793062 6.155187 1.605567 8.573259 0.435928 1.258667 0.971118 2.457981 1.089821 2.536776 5.736655 15.018042 16.337083 32.596396 31.088042 51.139727l-50.326199 45.959751c-6.828522 6.244214-7.314593 16.829294-1.080611 23.657816 3.310396 3.617387 7.829316 5.461385 12.368702 5.461385 4.033873 0 8.077979-1.446955 11.289114-4.380774l49.843198-45.518706c27.719318 28.872584 64.291259 58.343803 107.394962 82.944084l-35.411511 58.256822c-4.797259 7.909134-2.289136 18.206664 5.609765 23.014156 2.725064 1.645476 5.718235 2.438539 8.68173 2.438539 5.658883 0 11.17962-2.864234 14.331403-8.048303l36.493146-60.037375c49.872874 24.081465 106.835214 40.96397 167.923524 43.60717l0 67.016323c0 9.246595 7.502881 16.749476 16.749476 16.749476 9.246595 0 16.749476-7.502881 16.749476-16.749476l0-67.016323c61.073984-2.64627 118.037347-19.524682 167.920454-43.598984l36.496216 60.029188c3.151783 5.183046 8.67252 8.048303 14.331403 8.048303 2.963495 0 5.966898-0.793062 8.68173-2.438539 7.898901-4.807493 10.407024-15.105023 5.609765-23.014156l-35.410488-58.242496c43.10882-24.588001 79.69611-54.04387 107.441011-82.907245l49.786916 45.467541c3.211135 2.933819 7.255241 4.380774 11.289114 4.380774 4.539386 0 9.058306-1.843998 12.368702-5.461385C913.50442 493.605048 913.01835 483.019968 906.189827 476.775754z"></path>
              </svg>
            </div>
          </div>
        </template>
      </vxe-pager>

      <!-- 不计算总数分页 -->
      <vxe-pager v-else
                 :current-page="page.currentPage"
                 :page-size.sync="page.pageSize"
                 :total="tableDataTotal"
                 :page-sizes="pageSizes"
                 :layouts="['PrevPage', 'Number', 'NextPage', 'Sizes',]"
                 @page-change="bindChangeTablePage"
      >
        <template #right>
          <div @click="changeShowTotal(true)">
            <i style=" margin:5px 12px;font-size: 16px;" class="el-icon-view"></i>
          </div>
        </template>
      </vxe-pager>

    </template>
  </div>
</template>
<script>
export default {
  name: 'pager',
  props: ['pageSizes'],
  data() {
    return {
      page: {
        currentPage: 1,  // 当前页面
        pageSize: this.pageSizes[0],  // 页面数据量
        total: 0,  // 总数据量
      },
      isShowTotal: false,
      tableDataTotalNoPagination: 0,
      isSearch: false,
      tableDataTotal: 0,
    };
  },

  computed: {},

  mounted() {
    console.log('分页器初始化')
    this.$emit('changeTablePage', {currentPage: 1, pageSize: this.page.pageSize}, false)
  },

  watch: {
    tableDataTotal(newVal, oldVal) {
      console.log('tableDataTotal变化', oldVal, newVal)
      if (this.isSearch) {
        console.log('搜索重置')
        this.tableDataTotalNoPagination = newVal
        this.isSearch = false
      } else {
        this.tableDataTotalNoPagination = newVal > oldVal ? newVal : oldVal
      }
    }
  },

  methods: {
    clearStoreTableDataTotal() {
      this.isSearch = true
      this.isShowTotal = false
    },

    bindChangeTablePage(page) {
      this.page.currentPage = page.currentPage
      this.$emit('changeTablePage', page, this.isShowTotal)
    },

    reset() {
      console.log('父组件调用重置')
      this.page.currentPage = 1  // 当前页面
      this.page.total = 0  // 总数据量
      this.isShowTotal = false
    },

    changeShowTotal(flag) {
      this.isShowTotal = flag
      if (flag) {
        this.$emit('changeTablePage', this.page, flag)
      }
    },
  }
}
</script>
